import { BaseScenariosService } from './base-scenarios-service';
import { CarComparisonData } from '../types/carComparison';

interface CarScenario {
  id: string;
  name: string;
  description?: string;
  data: CarComparisonData;
  createdAt: number;
  userId?: string;
}

class CarScenariosService extends BaseScenariosService<CarScenario> {
  protected readonly STORAGE_KEY = 'larryshelp_car_scenarios';
  protected readonly SCENARIO_TYPE = 'car' as const;

  /**
   * Save a new car scenario
   */
  async saveCarScenario(scenario: Omit<CarScenario, 'id' | 'createdAt'>): Promise<string> {
    return this.saveScenario(scenario);
  }

  /**
   * Get all car scenarios
   */
  async getAllCarScenarios(): Promise<Record<string, CarScenario>> {
    return this.getAllScenarios();
  }

  /**
   * Get a specific car scenario by ID
   */
  async getCarScenario(id: string): Promise<CarScenario | null> {
    return this.getScenario(id);
  }

  /**
   * Update an existing car scenario
   */
  async updateCarScenario(id: string, updates: Partial<CarScenario>): Promise<boolean> {
    return this.updateScenario(id, updates);
  }

  /**
   * Delete a car scenario
   */
  async deleteCarScenario(id: string): Promise<boolean> {
    return this.deleteScenario(id);
  }

  /**
   * Get car scenarios as an array (for easier iteration)
   */
  async getCarScenariosArray(): Promise<CarScenario[]> {
    return this.getScenariosArray();
  }

  /**
   * Clear all car scenarios
   */
  async clearAllCarScenarios(): Promise<void> {
    return this.clearAllScenarios();
  }
}

export const carScenariosService = new CarScenariosService();
export default carScenariosService; 